export const TAB_SIZE = 992
export const STATIC_SERVER_URL = process.env.REACT_APP_STATIC_USER
export const STATIC_SERVER_URL_COMPANY = process.env.REACT_APP_STATIC_COMPANY